module.exports = {
  SelectReconciliationRules: '选择对账规则',
  ReturnToReconciliationNewVersion: '返回对账新版',
  StartReconciliation: '开始对账',
  Save: '保存',
  ManualReconciliation: '手工对账',
  CancelManualReconciliation: '取消手工对账',
  ShowAllReconciliationCost: '显示对账全部费用',
  ShowConsistentReconciliationCost: '显示对账一致费用',
  ShowPartiallyConsistentReconciliationFees: '显示对账部分一致费用',
  ShowUnmatchedCosts: '显示未匹配费用',
  Note: '说明：',
  Green: '绿色',
  IndicatesConsistentReconciliationResults: '表示对账结果一致；',
  Black: '黑色',
  IndicatesNoCorrespondingChargeFound: '表示未找到对应费用；',
  Red: '红色',
  IndicatesInconsistentAmounts: '表示金额不一致；',
  Orange: '橙色',
  IndicatesManualReconciliationComplete: '表示手工对账完成；',
  IfEtcPleaseGoModule: '如需处理差额等操作请至对账新版模块处理。',
  ImportExternalCharges: '导入外部费用',
  InternalSystemCharges: '系统内部费用',
  IfMaintainReconciliationRulesClick: '如需维护对账规则，请点击',
  ReconciliationRuleEngineConfiguration: '对账规则引擎配置。',
  ReconciliationConsistent: '对账一致',
  Items: '条',
  InconsistentAmounts: '金额不一致',
  CorrespondingChargesNotFound: '未找到对应费用',
  ImportSucceeded: '导入成功',
  CancelAllManualReconciliations: '取消全部手工对账',
  ExportAllComparisonResults: '导出全部对比结果',
  ExportConsistentComparisonResults: '导出一致对比结果',
  ExportDiscrepancyComparisonResults: '导出差异对比结果',
  BusinessNumber: '业务编号',
  ShipName: '船名',
  VoyageNumber: '航次',
  ContainerNumber: '箱号',
  ConfirmationStatus: '确认状态',
  ChargeName: '费用名称',
  Currency: '币种',
  PriceIncludingTax: '含税价',
  PriceExcludingTax: '不含税价',
  TaxRate: '税率',
  TaxAmount: '税额',
  Difference: '差额',
  ReconciliationAmount: '对账金额',
  UnitPrice: '单价',
  Quantity: '数量',
  InvoiceNumber: '发票号码',
  ReconciliationResult: '对账结果',
  ReconciliationRuleName: '对账规则名称',
  ComparisonOrder: '对比顺序',
  PleaseNeedToBeReconciliation: '请勾选需要对账的费用后进行手工对账。',
  ManualReconciliationSucceeded: '手动对账成功',
  AreCancelAllManualTime: '是否确定取消本次全部手工对账信息?',
  Tips: '提示',
  Yes: '是',
  No: '否',
  CancelAllManualReconciliationsSuccessful: '取消全部手工对账成功',
  RequestSucceededExporting: '请求成功，正在导出！',
  SavedSuccessfully: '保存成功',
  PleaseUseAndFillNumbers: '请勾选需要使用的对账规则，并使用数字填写对比顺序',
  Unconfirmed: '未确认',
  Confirmed: '已确认',
  ViewDetails: '查看详情',
  Return: '返回',
  ShowAllReconciliationFees: '显示对账全部费用',
  ShowFullyReconciledFees: '显示对账一致费用',
  ShowPartiallyReconciledFees: '显示对账部分一致费用',
  ShowUnmatchedFees: '显示未匹配费用',
  IndicatesReconciliationResultIsConsistent: '表示对账结果一致；',
  IndicatesCorrespondingFeeNotFound: '表示未找到对应费用；',
  IndicatesAmountInconsistency: '表示金额不一致；',
  IndicatesManualReconciliationCompleted: '表示手工对账完成；',
  ImportExternalFees: '导入外部费用',
  SystemInternalFees: '系统内部费用',
  ViewFile: '查看文件',
  System: '系统',
  Voyage: '航次',
  FeeName: '费用名称',
  TaxIncludedPrice: '含税价',
  TaxExcludedPrice: '不含税价',
  PleaseSelectOneRecord: '请勾选一条记录。',
  All: '全部',
  BankName: '银行名称',
  YouPermissionToViewData: '您没有权限查看该数据',
  QuickRetrieval: '快捷检索:',
  Selected: '选中',
  QuickRetrievalBillNumber: '快捷检索:账单号',
  BillClaims: '水单认领',
  FinancialReview: '财务审核',
  QuickRetrievalBusinessNumber: '快捷检索:业务编号',
  QuickRetrievalWaterBillNumber: '快捷检索:水单号',
  WaterBillClaims: '水单认领',
  Unused: '未使用',
  PleaseAWaterBillRecord: '请选择水单记录.',
  WaterReleasedAndCannotModified: '水单已发布，不能修改.',
  WaterClaimedAndCannotModified: '水单已被认领，不能修改.',
  WaterReturnedAndCannotModified: '水单已退回，不能修改.',
  WaterRecordsAndCannotVoided: '水单已有核销记录,不能作废.',
  WaterToFinancialVoucherVoided: '水单已经导出过财务凭证,不能作废.',
  Confirm: '确定',
  Cancel: '取消',
  NoBillRecordsToRelease: '没有要发布的水单记录.',
  NoRecordsToCancelRelease: '没有要取消发布的水单记录.',
  OnlyCanRevokeTheBill: '只有销账人本人可以撤销水单.',
  WaterCannotBeRevokedFirst: '已经复核过的水单无法撤销,请先取消复核.',
  ThisPleaseDeleteTheAgain: '此水单已生成财务凭证,请删除凭证后再次撤销.',
  WaterBillRevocationSuccessful: '水单撤销成功.',
  WaterBillRegistration: '水单登记',
  WaterBillNotSelected: '未选择水单.',
  AdvanceNoAdvancePaymentGenerated: '已做预收款认领，但是没生成预收款凭证.',
  Claimed: '已认领',
  ReceivableClaimCompleted: '已做过应收款认领.',
  PrepaymentClaimCompleted: '已做过预收款认领.',
  NoInTheCurrentBill: '当前水单没有多余的认领金额.',
  PleaseDataToBeClaimed: '请选择要认领的数据.',
  DomesticBill: '国内账单',
  InvoicingMetForReconciliationStatus: '对账单状态不符合开票要求!',
  AddToBillQueryList: '加入账单查询列表',
  ForeignBill: '国外账单',
  AgencyCommissionBill: '代理分成账单',
  Bill: '账单:',
  CreatePaymentRequestSelectFee: '创建付款申请-选择费用',
  SettlementTheBillCannotEmpty: '账单的结算代理不能为空！',
  CreatePaymentRequestDetailedInformation: '创建付款申请-详细信息',
  ReconciliationBill: '对账单',
  QuickRetrievalReconciliationBillNumber: '快捷检索:对账单号',
  Payable: '(应付)',
  Receivable: '(应收)',
  ReconciliationByFee: '对账-按费用',
  ReconciliationByBusiness: '对账-按业务',
  SelectImportTemplateSolution: '选择导入模板方案',
  Prompt: '提示',
  TemplateSolutionName: '模板方案名称',
  ToMaintainImportTemplatesClick: '如需维护导入模板，请点击',
  BasicDataImportTemplateSolutions: '基础资料-导入模板方案。',
  PleaseSelectASolution: '请选择方案',
  PleaseSettlementUnitBeforeImporting: '请查询结算单位后导入',
  NoFoundNoNeedReconcile: '未查询到相关费用，无需对账',
  PleaseBasicDataImportSolution: '请至基础资料导入模版方案中维护',
  ImportErrorPleaseReImport: '导入格式错误，请重新导入',
  PleaseSelectATemplate: '请选择模板',
  YouHavePermissionToOpen: '你没有打开',
  Module: '模块的权限',
  ViewPaymentRequestForm: '查看付款申请单',
  CreatingFormFailedPleaseAgain: '创建付款申请单失败，请重新保存！',
  ShanghaiAirFreightPayment: '上海空运付款',
  PaymentRequestDirect: '付款申请直达',
  IncludesReSelectPaymentNumber: '包含已开票的费用，请重新选择！付款申请单号：',
  CantDirectlyChangeConfigurationAgain: '不能直接财务审核,更改配置后再试！',
  Invoicing: '开票',
  QueryMethod: '查询方式',
  ByFee: '按费用',
  ByBusiness: '按业务',
  IncludeReceivables: '包含应收',
  NoteFilteredOutFullyBusiness: '注：此界面已过滤掉完全核销的费用业务',
  ConvertedToRMB: '折合RMB:',
  NextStep: '下一步',
  NotFound: '没有找到',
  CorrespondingPrintTemplate: '对应的打印模板',
  WarehouseEntryNumber: '进仓编号',
  BookingNumber: '订舱编号',
  CutOffDate: '截单日期',
  ProjectNumber: '项目编号',
  OverseasCustomerService: '海外客服',
  PaymentApplicationNumber: '付款申请单号',
  BillNumber: '账单号',
  SettlementObject: '结算对象',
  PickUpType: '揽货类型',
  MasterBillNumber: '主单号',
  HouseBillNumber: '分单号',
  EntrustingUnit: '委托单位',
  BusinessType: '业务类型',
  BusinessDate: '业务日期',
  VesselVoyage: '船名航次',
  DeparturePort: '起运港',
  DestinationPort: '目的港',
  StartingStation: '始发站',
  TerminusStation: '目的站',
  TransitStation: '过境站',
  DestinationPortAgent: '目的港代理',
  Sales: '销售',
  Operation: '操作',
  CustomerService: '客服',
  Documentation: '单证',
  BusinessReferenceNumber: '业务参考号',
  CustomBusinessType: '自定义业务类型',
  Accrued: '已计提',
  FinancialDate: '财务日期',
  DomesticForeign: '国内/国外',
  IncomeAndExpensesType: '收支类型',
  ExpenseStatus: '费用状态',
  Auditor: '审核人',
  ExpenseName: '费用名称',
  Unit: '单位',
  WriteOffAmount: '核销金额',
  UnwrittenOffAmount: '未销金额',
  ContactPerson: '联系人',
  Creator: '创建人',
  CreationDate: '创建日期',
  Remark: '备注',
  CorrelationNumber: '往来关联号',
  DelegationCorrelationNumber: '委托关联号',
  Carrier: '承运人',
  ConfirmationDate: '确认日期',
  ExpenseConfirmer: '费用确认人',
  RouteResponsiblePerson: '航线负责人',
  BillingDate: '开票日期',
  BillingHeader: '开票抬头',
  NeedForInvoicing: '是否需要开票',
  ConfirmationRemark: '确认备注',
  AccountingDate: '销账日期',
  BusinessStatus: '业务状态',
  CustomField1: '自定义字段1',
  CustomField2: '自定义字段2',
  CustomField3: '自定义字段3',
  ReceiptAndPaymentDate: '收付日期',
  SalesDepartment: '销售部门',
  ChooseExpense: '选择费用',
  CreatePaymentApplicationChooseExpense: '创建付款申请-选择费用',
  Other: '其他',
  YouViewOrPrintOthers: '你没有查看其它人上传或者打印的文件的权限.',
  BookingAgent: '订舱代理',
  PleaseSelect: '请选择需要',
  ProvisionalBusinesses: '计提的业务',
  ChangeOrderApprovalSuccess: '改单审核成功',
  ThisIsNotForProvision: '此业务不是待计提，不能计提!',
  ForPleaseChooseProvisionedBusiness: '为未计提,请选择已计提的业务！',
  FrontendErrorCallbackFailed: '前端error：回调失败',
  RouteManager: '路线负责人',
  ThisFieldCannotBeEmpty: '此项不允许为空',
  OperationAllowedToBeEmpty: '操作不允许为空',
  OperatingAllowedToBeEmpty2: '操作部门不允许为空',
  OperatingAllowedToBeEmpty3: '操作分公司不允许为空',
  DesignatedFreightForwarder: '指定货代理',
  OriginPortAgent: '起运港代理',
  TransportationCompany: '运输公司',
  Warehouse: '仓库',
  CustomsBroker: '报关行',
  CustomsDeclaration: '是否报关',
  PickingStorage: '内装箱/仓储',
  Storage: '是否仓储',
  CargoType: '揽货类型',
  ActualBillingWeight: '实际计费重量',
  QuotationNature: '约价性质',
  BookingType: '订舱性质',
  AllWriteOffs: '全部核销',
  BusinessCannotBeEmpty: '业务不能为空！',
  ReviewSuccess: '审核成功',
  ReviewFailed: '审核失败',
  ColumnDataConversionRendering: '列数据转换渲染:',
  SelectActualReceiptAndPayment: '选择实收实付',
  SingleWriteOffDetailXls: '单笔销账明细.xls',
  SentOut: '已经送出!',
  FetchDate: '取回日期',
  ReturnDate: '退还日期',
  DeclarationDate: '申报日期',
  SailingDate: '开船日期',
  OperationDate: '操作日期',
  Contracted: '已签约',
  ContractExpired: '合约失效',
  Uncontracted: '未签约',
  ViewReturnOrderFiles: '查看退单文件',
  OnlyWithTheSameStatus: '只能打印相同状态的单证。',
  HouseWaybillNumber: '分单号',
  RevokeFetch: '撤销取回',
  SentOutDate: '送出日期',
  ProvisionedBusiness: '计提的业务',
  ForPleaseChooseUnprovisionedBusiness: '为已计提,请选择未计提的业务！',
  ProvisionSuccess: '计提成功',
  CancellationProvisionsSuccess: '取消计提成功',
  ProvisionReview: '计提审核',
  ProvisionDate: '计提日期',
  Booking: '订舱',
  CustomsClearance: '报关',
  FormalHouseWaybill: '形式分单',
  CommodityInspection: '商检',
  Fumigation: '熏蒸',
  ForeignTrade: '外贸',
  CustomerAttribute: '客户属性',
  Dropdown: '下拉',
  OrderChannel: '订单渠道',
  ArrivalDate: '到港日期',
  ShippingOfBillOfLading: '提单发货地',
  OriginPortPOL: '起运港(POL)',
  DeliveryPlace: '交货地',
  Route: '航线',
  FinalDestination: '最终目的地',
  ShippingCompany: '船公司',
  ShipAgent: '船代',
  TradeMethod: '贸易方式',
  MasterWaybillTransportTerms: '主单运输条款',
  HouseWaybillTransportTerms: '分单运输条款',
  MasterWaybillFreightTerms: '主单运费条款',
  MasterWaybillPaymentLocation: '主单付款地点',
  HouseWaybillFreightTerms: '分单运费条款',
  HouseWaybillPaymentLocation: '分单付款地点',
  TradeTerms: '贸易条款',
  CargoDimensions: '货物尺寸',
  SpecialPriceExplanation: '特价说明',
  GrossWeightEntrustedActual: '毛重(委/实)',
  VolumeEntrustedActual: '体积(委/实)',
  Packing: '包装',
  NumberOfSmallPieces: '小件数',
  SmallPiecePacking: '小件数包装',
  ChargeableWeightRT: '计费重量RT',
  EnglishProductName: '英文品名',
  ShippingMarks: '唛头',
  HSCode: 'HS编号',
  ChineseProductName: '中文品名',
  CargoSales: '揽货销售',
  OperatingCompany: '操作公司',
  OperatingDepartment: '操作部门',
  OperationRequirements: '操作要求',
  OperationTips: '操作提示',
  AdditionalFeeTerms: '附加费条款',
  WarehouseEntryInformation: '入库信息',
  Remarks: '备注',
  CustomField4: '自定义字段4',
  Shipper: '发货人',
  SecondNotifyParty: '第二通知人',
  EntrustedInformation: '委托信息',
  VipCooperativeCustomer: 'Vip合作客户',
  DetailedInformation: '详细信息',
  Transshipment: '中转',
  AdditionalInformation: '附加信息',
  DoorToDoorLoadingCollection: '门点装箱/提货',
  SelfPickupSelfDelivery: '自拉自送',
  AutomaticAllocation: '自动配货',
  WarehousingInformation: '获取进仓',
  CargoBoxInformation: '箱货信息',
  OperationInformation: '操作信息',
  CustomInformation: '自定义信息',
  CustomerShippingInformation: '客户发运信息',
  CodeRetrieval: '代码检索',
  OperationCannotBeEmpty: '操作不允许为空',
  OperationDepartmentCannotBeEmpty: '操作部门不允许为空',
  OperationBranchCannotBeEmpty: '操作分公司不允许为空',
  DesignatedFreightAgent: '指定货代理',
  DeparturePortAgent: '起运港代理',
  Client: '委托单位',
  DeclaringCustoms: '是否报关',
  ContainerPackingWarehouse: '内装箱/仓储',
  WarehouseService: '是否仓储',
  PricingNature: '约价性质',
  BookingNature: '订舱性质',
  PleaseARecordToView: '请选择一条记录进行查看',
  WriteOff: '全部核销',
  AgeOfAccount: '当票账龄',
  CommissionAmount: '提成金额',
  TradeType: '贸易类型',
  PayableWriteOffStatus: '应付核销状态',
  ReceivableWriteOffStatus: '应收核销状态',
  Date: '日期',
  PleaseEnterTheReviewDate: '请输入审核日期',
  PleaseConfirmTheReviewDate: '请确认审核日期',
  FailedToGetDetails: '获取详情失败',
  AfterForFinancialReviewContinue: '打印利润分析表后, 本单业务将提交财务审核,不可再更改.是否继续？',
  Warning: '警告',
  PleaseNumberBeforePrintingTable: '请输入箱封号后，打印利润分析表。',
  PleaseSelectCost: '请选择费用',
  ConfirmTheSingleCostDate: '确定要修改单笔费用财务日期吗？',
  CostFinancialDateModificationSuccessful: '费用财务日期修改成功',
  ConfirmModifyTheFinancialDate: '确定要修改财务日期吗？',
  FinancialDateModificationSuccessful: '财务日期修改成功',
  ReviewBusinessDateDoContinue: '审核日期小于业务日期，是否继续？',
  ConfirmReviewOfTheseOrders: '确定审核这些单子吗？',
  ThisIsNotIn: '该业务不是[',
  AllowedToReviewCheck: ']状态，不允许审核，请检查！',
  ConfirmToAllowAmendments: '确定要允许改单吗？',
  AmendmentAllowedSuccessful: '允许改单成功',
  NoOrNotInStatus: '未选择费用或不是审核状态',
  ConfirmCancellationOfReview: '确定取消审核吗？',
  CostStatusUpdateSuccessful: '费用状态更新成功',
  NoOrNotInStatus2: '未选择费用或不是提交状态',
  NoOrNotInStatus3: '未选择费用或不是审核状态！',
  NoOrNotInStatus4: '未选择费用或不是提交状态！',
  ConfirmToCancelReview: '确定要取消审核吗？',
  CancelReviewSuccessful: '取消审核成功',
  LCLIndividuallyPleaseReviewBill: '拼箱小票不能单独审核，请审核主票。',
  FrontEndErrorCallbackFailed: '前端error：回调失败',
  CostStatusUpdateSuccessful2: '费用状态更新成功。',
  PleaseStaffInformationBeforePrinting: '请录入销售人员信息再打印！',
  TheNotEnteredSales: '以下几单没有输入销售人员信息：\n',
  PleaseEnterBeforePrinting: '\n请输入后再打印！',
  PleaseWantToModifyDate: '请选择需要修改业务日期的业务',
  BusinessDateModificationSuccessful: '业务日期修改成功',
  PleaseSelectOnlyOneRecord: '请只选择一条记录',
  InvoicePool_OnlyWithAttachment: '有发票附件',
  PleaseSelectBusiness: '请选择业务。',
  SelectedDataIncludes: '选择的数据中包含',
  StatusAllowedToReviewCheck: '状态的业务，不允许审核，请检查！',
  StatusToCancelReviewCheck: '状态的业务，不允许取消审核，请检查！',
  BatchReviewFailed: '批量审核失败',
  ReviewLessThanBusinessContinue: '审核日期小于业务日期,是否继续?',
  ConfirmToReviewTheseOrders: '确定审核这些单子吗?',
  FinancialReviewList: '财务审核列表',
  QueryFailed: '查询失败',
  PleaseBusinessYouWantPrint: '请选择需要打印的业务',
  SendEmail: '发送邮件',
  N1ContactAndEmailMaintained: '1.未维护联系人和邮箱:',
  N1AMaintainedContactEmail: '1.请选择已维护的联系人以及邮箱:',
  N2PleaseAddOtherEmails: '2.请补充其他邮箱:',
  MultipleShouldBeSeparatedCommas: '(多个邮箱地址请以逗号隔开)',
  Send: '发送',
  InvoiceUuidCannotBeEmpty: '发票uuid不能为空！',
  SettlementIdCannotBeEmpty: '结算单位id不能为空！',
  PleaseEnterEmail: '请输入邮箱',
  SendLog: '发送日志',
  Sender: '发送人',
  YouViewOtherPeoplesFiles: '你没有查看其它人上传或者打印的文件的权限.',
  CostName: '费用名称',
  PaymentType: '收付类型',
  BillingExchangeRate: '开票汇率',
  BillingAmount: '开票金额',
  BillBusinessNumber: '账单/业务号',
  BillBusinessDate: '账单/业务日期',
  PriceExclusiveOfTax: '不含税价',
  ResetColumn: '重置列',
  OnlyNumberCanBeSelected: '只能选择1个发票号!',
  Used: '已使用',
  Example8180onlyUSDIsInvoice: '例: USD:355/汇率:6.8180/此票只收美金',
  PleaseNote: '注意事项：',
  ChangesTheNextInvoiceConfiguration: '保存配置后从下一张发票开始生效',
  EBeLessThanCharacters: '电票备注须小于100个字',
  PaperBeLessThanCharacters: '纸票备注须小于200个字',
  AutomaticTheTextDoesntLine: '一行显示不下时会自动换行',
  PDFDisplayUpToLines: 'PDF格式发票备注栏最多显示三行',
  InvoiceType: '发票类型',
  RMBExpenseItemName: 'RMB费用项目名称',
  USDExpenseItem: 'USD费用项目',
  DefaultItemName: '是否默认项目名称',
  Billing: '开票',
  Add: '新增',
  InternationalFreightForwardingFee: '国际代理运费',
  InternationalShippingFee: '国际代理海运费',
  InternationalFreightServiceFee: '国际货代服务费',
  FreightForwardingFee: '货运代理费',
  MarkBill: '标记账单',
  MarkCharge: '标记费用',
  MarkJob: '标记业务',
  MarkRecordExistsNoMarkedCharge: '记录中存在未标记的费用，请选择已标记的费用',
  MarkRecordExistsNoMarkedJob: '记录中存在未标记的业务，请选择已标记的业务',
  PleaseSelectChargeToMark: '请选择需要标记的费用。',
  MarkRecordExistsMarkedCharge: '记录中存在已标记的费用，请选择未标记的费用。',
  PleaseSelectJobToMark: '请选择需要标记的业务。',
  MarkRecordExistsMarkedJob: '记录中存在已标记的业务，请选择未标记的业务。',
  AnnotationDate: '标注日期:',
  Annotator: '标注人:',
  InvoiceInquiry: '发票查询',
  QuickSearchInvoiceNumber: '快捷检索:发票号码',
  SecondaryDownload: '次下载',
  Sent: '已发送',
  Unsent: '未发送',
  Total: '合计',
  VoidingBulkOperationsPleaseSelectClickVoid: '作废发票不支持批量操作\n请勾选一张发票再点击【作废】',
  OriginalToReissueTheExpenses: '原费用将被红冲，如需重开发票，请注意添加正确费用！',
  OriginalTheSystemWillExpenses: '原费用将被红冲，系统自动生成与原费用相同的费用！',
  CreditSuccess: '红冲成功！',
  BankAccount: '银行账号',
  OnlyElectronicInvoicesPleaseType: '仅支持批量下载电子发票，请检查发票种类。',
  TotalSelection: '共勾选',
  StatusUnknown: '状态未知',
  UnwrittenAmount: '未销金额',
  WrittenOffAmount: '核销金额',
  SearchByExpense: '按费用查询',
  QuickSearchBusinessNumber: '快捷检索:业务编号',
  SearchByBusiness: '按业务查询',
  SearchByBill: '按账单查询',
  QuickSearchBillNumber: '快捷检索:账单号',
  SearchByReconciliationBill: '按对账单查询',
  QuickSearchReconciliationBillNumber: '快捷检索:对账单号',
  SearchByExpenseCredit: '按费用查询(红冲)',
  SearchByBusinessCredit: '按业务查询(红冲)',
  SearchByBillCredit: '按账单查询(红冲)',
  SearchByReconciliationBillCredit: '按对账单查询(红冲)',
  SearchingYouSureYouAgo: '若选的日期范围大于2年，会影响数据加载速度，确定查询两年外的数据吗？',
  SelectClosingDate: '选择关账日期',
  ClosingDate: '关账日期:',
  FinancialClosing: '财务关账',
  BusinessClosing: '业务关账',
  ClosingPerson: '关帐人',
  ClosingMonth: '关帐月份',
  ClosingBranch: '关帐分公司',
  ClosingType: '关账类型',
  TheHasAlreadyBeenClosed: '当前选择的月份已关过帐.',
  ClosingSuccess: '关帐成功',
  PleaseSelectAClosingRecord: '请选择关帐记录.',
  TheBeenAuditedAndCancelled: '关帐记录已审核,无法取消.',
  AreWantToCancelRecord: '确定要取消关帐记录吗？',
  ClosingRecordCancelled: '已取消关帐记录',
  Year: '年',
  Month: '月',
  PleaseSelectARecord: '请选择记录。',
  AreWantToAuditRecord: '审核后关帐记录无法取消，确定吗？',
  OperationSuccessful: '操作成功。',
  ToYouSureYouAudit: '取消审核后可以取消关帐日期，确定吗？',
  NoMatchingPrintTemplatesFound: '没有找到对应的打印模板',
  FinancialAudit: '财务审核',
  HangingWaterBill: '挂水单',
  ReceivedPayment: '收到款',
  GotReceipt: '拿到回单',
  InternationalBill: '国外账单',
  AgencySharingBill: '代理分成账单',
  PaymentRequestQuery: '付款申请查询',
  QuickSearchPaymentRequestNumber: '快捷检索:付款申请号',
  ChangeExpenseApplicationQuery: '更改费用申请查询',
  QuickSearchApplicationSerialNumber: '快捷检索:申请流水号',
  SearchByInvoice: '按发票查询',
  BankAccountNumber: '银行账号',
  NoCorrespondingPrintTemplateFound: '没有找到对应的打印模板',
  SearchByCost: '按费用查询',
  ReleasePleasePrepareForWithholding: '已放单，请做扣货准备.',
  StatusUpdatedSuccessfully: '状态更新成功.',
  BillOfLadingConfirmationDocument: '提单确认件',
  DataCustomersReleaseNotAllowed: '数据中含有黑名单客户，不可放单！',
  AreToUseAnNumber: '确认使用空的放单号吗?',
  Invoice: '开票',
  EquivalentToRMB: '折合RMB:',
  ReconciliationFlowNumber: '销账流水号',
  CounterpartyUnit: '对方单位',
  OurBank: '我方银行',
  PaymentNoticeNumber: '付款通知号',
  VoucherNumber: '凭证号',
  BankSlipNumber: '银行水单号',
  ReconciliationPerson: '销账人',
  ReconciliationDate: '销账日期',
  ReceiptpaymentDate: '收付日期',
  VoucherDate: '凭证日期',
  SlipStatus: '水单状态',
  ReceiptpaymentMethod: '收付方式',
  WhetherPrepaid: '是否预付',
  Amount: '金额',
  AmountReconciled: '已销金额',
  Balance: '余额',
  ActualAmountReceived: '实收金额',
  ActualPaymentAmount: '实付金额',
  FinancialExpense: '财务费用',
  ExchangeGainloss: '汇兑损益',
  SmallHead: '零头短账',
  OriginalCurrencyDifference: '原币汇差',
  Review: '复核',
  ReviewDate: '复核日期',
  Void: '作废',
  InvoiceInformation: '开票信息',
  AccountPerioddays: '账期（天）',
  CounterpartyVoucherNumber: '对方凭证号',
  VoucherDate2: '凭证日期2',
  FailedToModifyReconciliation: '修改销账失败',
  OffsetSearchAndSelectThe: '对冲销账:请查询并选择要对冲的全部',
  Fees: '费用',
  Invoices: '发票',
  Statements: '账单',
  AccountStatements: '对账单',
  PaymentApplications: '付款申请',
  PlatformCustomerService: '平台客服',
  FailedToRevokeReconciliation: '撤销销账失败',
  Equivalent: '折合',
  PaymentAmount: '付款金额',
  PaymentMethod: '付款方式',
  NotUsed: '未使用',
  PendingSlip: '挂水单',
  ReceivedReceipt: '拿到回单',
  Reconciliation: '销账',
  Company1: '公司1',
  CloseAndCopyFlowNumber: '关闭并复制流水号',
  Close: '关闭',
  CopySuccessful: '复制成功',
  IfLoadingSpeedAreAgo: '若选的日期范围大于2年，会影响数据加载速度，确定查询两年外的数据吗？',
  FinancialComprehensiveQuery: '财务综合查询',
  ExportEstimationForm: '导出预估表',
  ExportingMailboxLaterPleaseMailbox: '正在导出，稍后将发送至登陆人邮箱，请至邮箱查看文件。',
  ChineseName: '中文名称',
  ClosingRecords: '关帐记录',
  ClosingReview: '关帐审核',
  PleaseCheckARecord: '请勾选一条记录。',
  PleaseAReconciliationRuleName: '请输入对账规则名称',
  PleaseSelectABranch: '请选择分公司',
  DeleteSuccessful: '删除成功',
  PleaseReconciliationRuleToEdit: '请选择对账规则编辑',
  PleaseTheMatchingFieldOrder: '请输入匹配字段顺序',
  PleaseTheMatchingFieldName: '请选择匹配字段名称',
  PleaseTheContrastFieldOrder: '请输入对比字段顺序',
  PleaseTheContrastFieldName: '请选择对比字段名称',
  PleaseTheContrastFieldOperation: '请选择对比字段操作',
  EnterReconciliationAmount: '请输入内部表格的【对账金额】，确保左右两边勾选的对账金额合计一致后进行手工对账。',
  XNotAllowViewOrDownload: '{0}文件不允许任何人查看或下载.',
  NoPermissionView: '你没有权限查看或下载{0}文件',
  SelectedNotAllowedToCheck: '选择的数据中有不是{0}状态的业务，不允许审核，请检查！',
  N0isBeVoidedPleaseNote: '【{0}】是电子发票不可作废，请红冲',
  N0isCannotBeVoidedNote: '【{0}】是跨月发票不可作废，请红冲',
  N0VoidedAndCannotCredited: '{0}已经作废 ,不能再红冲！',
  N0hasOffAndCannotCredited: '{0}已经核销 ,不能红冲！',
  N0ItemsDownloadable: '条，可下载',
  N0ItemsConfirmDownload: '条，是否确认下载?',
  TelexContact0ToApplication: '已做电放申请，请联系{0}取消电放申请.',
  DocumentaryStatus: '制单状态',
  GotIt: '知道了',
  CurrencyConversionColumnSet: '折合币种显示列设置',
  CurrencyConversionSet: '折合币种设置',
  ShowColumns: '显示列',
  CurrencyConversionColumnSetNote: '注：选择币种后，系统会自动生成所选币种的原币金额、或费用折合此币种的金额显示列',
  CheckAtLeastOneDisplayColumn: '请最少勾选一个显示列。',
  InvoiceWrittenOffWantDeleteIt: '发票已核销，请确定是否删除？',
  InvoiceWrittenOffWantRevokedIt: '发票已核销，请确定是否作废？',
  InvoiceWrittenOffWantRedPunchIt: '发票已核销，请确定是否红冲？',
  RedPunchInvoice: '红冲发票',
  BatchCheckRedFlushInvoiceMessageOne: '1.若选择开票有误，系统将按原费用自动生成待开票新费用',
  BatchCheckRedFlushInvoiceMessageTwo: '2.若选择服务终止、销售折让、销货退回，请注意手动重新录入正确费用',
  BatchCheckRedFlushInvoiceMessageThree: '2.若选择服务终止、销售折让，请注意手动重新录入正确费用',
  IncorrectInvoiceInformation: '发票信息有误',
  IncorrectChargeInformation: '费用信息有误',
  BatchCheckRedPunchInvoiceMessageOne: '1.若选择发票信息有误，系统将按原费用自动生成待开票新费用',
  BatchCheckRedPunchInvoiceMessageTwo: '2.若选择费用信息有误，请注意手动重新录入正确费用',
  ContinueRedPunchAtVoucher: '含已生成凭证的发票号，请确定是否红冲？',
  WhtDeduction: 'WHT扣减',
  WhtDeductionAmount: 'WHT扣减额',
  ReceivableWHTTaxAmount: '应收减WHT税额',
  PayableWHTTaxAmount: '应付减WHT税额',
  TotalExcludingTax: '合计（不含税）',
  TotalIncludingTax: '合计（含税）',
  NewGeneration: '推送新一代状态',
  PushState: '推送状态',
  PushFailReason: '推送失败原因',
  ManualMatching: '人工匹配',
  SelectBusinessNumber: '选择对应业务编号',
  ManualMatchByBoxNo: '按箱号人工匹配',
  ManualMatchByWarehouseNo: '按进仓编号人工匹配',
  FreeMatch: '自由匹配',
  SelectSameSupplierNumberMatch: '请选择相同的进供应商编号，进行人工匹配。',
  BusinessNoMblSoNoNotEmpty: '业务编号、主单号、SO NO不能都为空',
  SelectCorrespondeBusiness: '请选择对应的业务',
  CostSyncColudStatus: '费用同步云平台状态',
  SyncCloudExceptionReason: '同步云平台异常原因',
  ManualSynchronization: '人工同步',
  SelectNotSyncManualPush: '请勾选同步状态为未同步的数据，进行人工推送',
  SyncChargeNotSplit: '已同步的费用，不可进行费用拆分',
  SyncCloudPlatformStatus: '同步云平台状态',
  InvoiceNoEmptyNotPush: '发票号为空，不可推送',
  InvoicePushNotAgain: '已推送的发票，请勿重复推送',
  SentYongYouRedFlush: '已推送用友，请进行红冲操作',
  InvoiceTitleNotSync: '发票抬头"{0}"尚未同步用友，请先同步。',
  OnlySupportInternal: '接口不包含国外费用，请选择国内发票。',
  NotSupportMultiCurrency: '存在混合发票币种，无法推送用友。请调整数据。',
  OnlySupportRmb: '发票币种不是RMB，不可推送用友。',
  PayableInvoiceActualReceiptDateEmpty: '应付发票实际收票日期不可为空，请先填写',
  PushYongYouInvoiceNeedRMB: '推送用友发票，需要发票币种为RMB',
  OffsetRedPunchTipU8C: '根据集团要求，红冲发票不可推送，请线下处理',
  AccountsReceivable: '应收：',
  PayableColon: '应付：',
  PrintByAccountNumber: '按账单号打印',
  PrintAccordingAccountNumber: '按对账单号打印',
  PrintByPaymentRequestNumber: '按付款申请号打印',
  PushUFIDANeedReceiptDate: '为推送用友凭证系统，应付发票需填写实际收票日期',
  WhenShareFinanceCost: '（分摊财务费用时）',
  ReceivablesVerificationStatus: '应收业务核销状态',
  UnlockLedgerBatchNo: '批次号',
  UnlockLedgerApplyUser: '申请人',
  UnlockLedgerStatus: '状态',
  UnlockLedgerOrderCount: '订单数',
  UnlockLedgerDeclaredImpact: '申报毛利影响',
  UnlockLedgerBeforeProfit: '解锁前毛利',
  UnlockLedgerAfterProfit: '解锁后毛利',
  UnlockLedgerActualImpact: '实际毛利影响',
  UnlockLedgerRelockTime: '自动重锁时间',
  UnlockLedgerApplyTime: '提交时间',
  UnlockLedgerStatus0: '审批中',
  UnlockLedgerStatus1: '解锁中',
  UnlockLedgerStatus2: '已重锁',
  UnlockLedgerStatus3: '已拒绝',
  UnlockLedgerManualRemarks: '人为锁单备注',
  UnlockLedgerStatus9: '异常',
  UnlockLedgerDetailTitle: '解锁申请详情',
  UnlockLedgerApplyInfo: '申请信息',
  UnlockLedgerSpNo: '企微审批单号',
  UnlockLedgerUnlockTime: '解锁完成时间',
  UnlockLedgerPlanRelockTime: '计划重锁时间',
  UnlockLedgerActualRelockTime: '实际重锁时间',
  UnlockLedgerFailReason: '异常原因',
  UnlockLedgerJobs: '订单快照',
  UnlockLedgerJobNo: '订单号',
  UnlockLedgerCustomerName: '客户名称',
  UnlockLedgerBeforeReceivable: '解锁前应收',
  UnlockLedgerBeforePayable: '解锁前应付',
  UnlockLedgerAfterReceivable: '重锁后应收',
  UnlockLedgerAfterPayable: '重锁后应付',
  UnlockLedgerDiffTab: '费用差异明细',
  UnlockLedgerJobFilter: '按订单筛选',
  UnlockLedgerChargeName: '费用名称',
  UnlockLedgerChangeType: '变更类型',
  UnlockLedgerChangeType0: '新增',
  UnlockLedgerChangeType1: '修改',
  UnlockLedgerChangeType2: '删除',
  UnlockLedgerFieldChanges: '变更字段',
  UnlockLedgerModifyUser: '修改人',
  UnlockLedgerModifyTime: '修改时间',
  UnlockLedgerDiffEmptyTip: '暂无差异明细（费用差异在重锁时生成）',
  UnlockLedgerTip: '已锁订单费用修改需走企微审批解锁；审批通过自动解锁，3天后01:00自动重锁；全程差异留痕'
}
